import clsx from 'clsx'
import Link from 'next/link'
import React from 'react'

import { Badge } from '@wartek-id/badge'
import { Icon } from '@wartek-id/icon'
import { Text } from '@wartek-id/text'

import Checkmark from 'components/CheckmarkNoFill'

import type { TAPIGetSJTPPGDaljabResponse } from 'typings/ppg-daljab'

export interface PostTestCardProps {
  item: TAPIGetSJTPPGDaljabResponse
  isLocked?: boolean
  isActive?: boolean
}

const CheckmarkIcon = ({ isPassed }: { isPassed: boolean }) => {
  return (
    <Checkmark
      className={clsx(isPassed ? 'text-success' : 'text-icon-disabled')}
    />
  )
}

const SJTCard = ({ isLocked = true, item }: PostTestCardProps) => {
  let url: string

  if (item.is_done) {
    url = `/topik/sjt/result?topik=${item.topic_id}&sjt=${item.id}`
  } else {
    url = `/topik/sjt?topik=${item.topic_id}&sjt=${item.id}`
  }

  const description = 'Latihan Pemahaman Modul'

  return (
    <div className="flex-grow flex-shrink rounded">
      <div
        className={clsx([
          'relative',
          'min-h-[70px] p-3 w-full',
          'border border-subdued',
          'bg-white',
          isLocked ? 'rounded-t-lg' : 'rounded-lg',
        ])}
      >
        <div className={clsx('flex items-center')}>
          <div className="w-6 h-6">
            <CheckmarkIcon isPassed={item.is_done} />
          </div>
          <div className="ml-3">
            {!isLocked ? (
              <Link href={url} passHref legacyBehavior>
                <a
                  href={url}
                  data-testid="sjt-card-url"
                  className={clsx(
                    'overlay-link block font-bold',
                    'text-type-basic-dark'
                  )}
                >
                  {item.name}
                </a>
              </Link>
            ) : (
              <Text variant="heading-sm" className="overlay-link block">
                {item.name}
              </Text>
            )}
            <div className="pr-2">
              <Text variant="body-sm" color="disabled">
                {description}
              </Text>
            </div>
          </div>
          <div className="ml-auto">
            <div className="flex items-center">
              {item.is_done && (
                <Badge variant="success" className="mr-2">
                  {item.final_score}
                </Badge>
              )}
            </div>
          </div>
        </div>
      </div>
      {isLocked && (
        <div
          className={clsx(
            'flex items-center px-3 py-2  rounded-b-lg',
            'bg-surface-neutral-default'
          )}
        >
          <Icon className="mr-3">lock</Icon>
          <Text variant="body-sm">Pelajari unit di atas terlebih dahulu</Text>
        </div>
      )}
    </div>
  )
}

export default SJTCard
